module.exports = __webpack_public_path__ + "static/media/bell.f61f9e0b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/bell.svg
// module id = 534
// module chunks = 0